import { render, staticRenderFns } from "./CustomerFeedback.vue?vue&type=template&id=51c2c4ff"
import script from "./CustomerFeedback.vue?vue&type=script&lang=js"
export * from "./CustomerFeedback.vue?vue&type=script&lang=js"
import style0 from "./CustomerFeedback.vue?vue&type=style&index=0&id=51c2c4ff&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./CustomerFeedback.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports